import { j as i } from "./jsx-runtime.DGlMoOmv.js";
import * as o from "react";
import "react-dom";
import { c as w } from "./index.CxSWpsOB.js";
function $(e, t = []) {
  let r = [];
  function n(a, c) {
    const l = o.createContext(c), u = r.length;
    r = [...r, c];
    const d = (f) => {
      const { scope: v, children: m, ...p } = f, _ = v?.[e]?.[u] || l, L = o.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ i.jsx(_.Provider, { value: L, children: m });
    };
    d.displayName = a + "Provider";
    function A(f, v) {
      const m = v?.[e]?.[u] || l, p = o.useContext(m);
      if (p) return p;
      if (c !== void 0) return c;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return [d, A];
  }
  const s = () => {
    const a = r.map((c) => o.createContext(c));
    return function(l) {
      const u = l?.[e] || a;
      return o.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: u } }),
        [l, u]
      );
    };
  };
  return s.scopeName = e, [n, k(s, ...t)];
}
function k(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((s) => ({
      useScope: s(),
      scopeName: s.scopeName
    }));
    return function(a) {
      const c = n.reduce((l, { useScope: u, scopeName: d }) => {
        const f = u(a)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return o.useMemo(() => ({ [`__scope${t.scopeName}`]: c }), [c]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
function Z(e) {
  const t = o.useRef(e);
  return o.useEffect(() => {
    t.current = e;
  }), o.useMemo(() => (...r) => t.current?.(...r), []);
}
var j = globalThis?.document ? o.useLayoutEffect : () => {
};
function S(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function B(...e) {
  return (t) => {
    let r = !1;
    const n = e.map((s) => {
      const a = S(s, t);
      return !r && typeof a == "function" && (r = !0), a;
    });
    if (r)
      return () => {
        for (let s = 0; s < n.length; s++) {
          const a = n[s];
          typeof a == "function" ? a() : S(e[s], null);
        }
      };
  };
}
var y = o.forwardRef((e, t) => {
  const { children: r, ...n } = e, s = o.Children.toArray(r), a = s.find(O);
  if (a) {
    const c = a.props.children, l = s.map((u) => u === a ? o.Children.count(c) > 1 ? o.Children.only(null) : o.isValidElement(c) ? c.props.children : null : u);
    return /* @__PURE__ */ i.jsx(x, { ...n, ref: t, children: o.isValidElement(c) ? o.cloneElement(c, void 0, l) : null });
  }
  return /* @__PURE__ */ i.jsx(x, { ...n, ref: t, children: r });
});
y.displayName = "Slot";
var x = o.forwardRef((e, t) => {
  const { children: r, ...n } = e;
  if (o.isValidElement(r)) {
    const s = W(r), a = z(n, r.props);
    return r.type !== o.Fragment && (a.ref = t ? B(t, s) : s), o.cloneElement(r, a);
  }
  return o.Children.count(r) > 1 ? o.Children.only(null) : null;
});
x.displayName = "SlotClone";
var V = ({ children: e }) => /* @__PURE__ */ i.jsx(i.Fragment, { children: e });
function O(e) {
  return o.isValidElement(e) && e.type === V;
}
function z(e, t) {
  const r = { ...t };
  for (const n in t) {
    const s = e[n], a = t[n];
    /^on[A-Z]/.test(n) ? s && a ? r[n] = (...l) => {
      a(...l), s(...l);
    } : s && (r[n] = s) : n === "style" ? r[n] = { ...s, ...a } : n === "className" && (r[n] = [s, a].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function W(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var T = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], h = T.reduce((e, t) => {
  const r = o.forwardRef((n, s) => {
    const { asChild: a, ...c } = n, l = a ? y : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ i.jsx(l, { ...c, ref: s });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), C = "Avatar", [D, de] = $(C), [H, b] = D(C), N = o.forwardRef(
  (e, t) => {
    const { __scopeAvatar: r, ...n } = e, [s, a] = o.useState("idle");
    return /* @__PURE__ */ i.jsx(
      H,
      {
        scope: r,
        imageLoadingStatus: s,
        onImageLoadingStatusChange: a,
        children: /* @__PURE__ */ i.jsx(h.span, { ...n, ref: t })
      }
    );
  }
);
N.displayName = C;
var F = "AvatarImage", E = o.forwardRef(
  (e, t) => {
    const { __scopeAvatar: r, src: n, onLoadingStatusChange: s = () => {
    }, ...a } = e, c = b(F, r), l = q(n, a.referrerPolicy), u = Z((d) => {
      s(d), c.onImageLoadingStatusChange(d);
    });
    return j(() => {
      l !== "idle" && u(l);
    }, [l, u]), l === "loaded" ? /* @__PURE__ */ i.jsx(h.img, { ...a, ref: t, src: n }) : null;
  }
);
E.displayName = F;
var P = "AvatarFallback", M = o.forwardRef(
  (e, t) => {
    const { __scopeAvatar: r, delayMs: n, ...s } = e, a = b(P, r), [c, l] = o.useState(n === void 0);
    return o.useEffect(() => {
      if (n !== void 0) {
        const u = window.setTimeout(() => l(!0), n);
        return () => window.clearTimeout(u);
      }
    }, [n]), c && a.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ i.jsx(h.span, { ...s, ref: t }) : null;
  }
);
M.displayName = P;
function q(e, t) {
  const [r, n] = o.useState("idle");
  return j(() => {
    if (!e) {
      n("error");
      return;
    }
    let s = !0;
    const a = new window.Image(), c = (l) => () => {
      s && n(l);
    };
    return n("loading"), a.onload = c("loaded"), a.onerror = c("error"), a.src = e, t && (a.referrerPolicy = t), () => {
      s = !1;
    };
  }, [e, t]), r;
}
var G = N, K = E, J = M;
const Q = (e, t) => /* @__PURE__ */ i.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: t, ...e, children: /* @__PURE__ */ i.jsx("path", { fill: "currentColor", d: "M6 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm-1.476 5.684C6.033 11.252 7.941 11 10 11c2.06 0 3.968.252 5.477.685 1.246.357 1.848 1.813 1.06 2.928A7.991 7.991 0 0 1 10.001 18a7.991 7.991 0 0 1-6.537-3.387c-.788-1.115-.186-2.572 1.06-2.929Z" }) }), U = o.forwardRef(Q), X = (e, t) => /* @__PURE__ */ i.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref: t, ...e, children: /* @__PURE__ */ i.jsx("path", { fill: "currentColor", d: "M7 7a5 5 0 1 1 10 0A5 5 0 0 1 7 7Zm-2.084 7.238c1.881-.62 4.373-.988 7.084-.988 2.71 0 5.202.368 7.084.988 1.434.472 2.035 2.148 1.167 3.413A9.99 9.99 0 0 1 12 22a9.99 9.99 0 0 1-8.251-4.349c-.868-1.265-.268-2.941 1.167-3.413Z" }) }), Y = o.forwardRef(X), ee = (e, t) => /* @__PURE__ */ i.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 28, height: 28, fill: "currentColor", viewBox: "0 0 28 28", ref: t, ...e, children: /* @__PURE__ */ i.jsx("path", { fill: "currentColor", d: "M8.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm-3.006 8.741C7.714 15.465 10.718 15 13.999 15c3.28 0 6.285.465 8.505 1.241a2.475 2.475 0 0 1 1.193 3.827A11.985 11.985 0 0 1 14 25a11.985 11.985 0 0 1-9.7-4.931 2.475 2.475 0 0 1 1.193-3.828Z" }) }), te = o.forwardRef(ee), re = (e, t) => /* @__PURE__ */ i.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "currentColor", viewBox: "0 0 32 32", ref: t, ...e, children: /* @__PURE__ */ i.jsx("path", { fill: "currentColor", d: "M9.5 9a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM5.68 19.297c2.592-1.017 6.278-1.63 10.32-1.63 4.04 0 7.726.613 10.316 1.629 1.805.708 2.412 2.838 1.37 4.414A13.988 13.988 0 0 1 16 30a13.988 13.988 0 0 1-11.687-6.29c-1.042-1.575-.436-3.705 1.369-4.413Z" }) }), R = o.forwardRef(re), ne = (e, t) => /* @__PURE__ */ i.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, fill: "currentColor", viewBox: "0 0 48 48", ref: t, ...e, children: /* @__PURE__ */ i.jsx("path", { fill: "currentColor", d: "M13.999 14c0-5.523 4.477-10 10-10s10 4.477 10 10c0 5.522-4.478 10-10 10-5.523 0-10-4.478-10-10ZM10.18 28.862C13.9 27.692 18.744 27 24 27c5.255 0 10.096.692 13.814 1.861 2.954.93 4.195 4.4 2.32 6.957C36.497 40.776 30.624 44 23.997 44c-6.625 0-12.498-3.223-16.135-8.18-1.875-2.556-.635-6.027 2.319-6.957Z" }) }), g = o.forwardRef(ne), I = o.createContext(32), oe = o.forwardRef(({
  className: e,
  size: t = 32,
  ...r
}, n) => /* @__PURE__ */ i.jsx(I.Provider, { value: t, children: /* @__PURE__ */ i.jsx(G, { ref: n, className: w("tw-relative tw-flex tw-shrink-0 tw-overflow-hidden tw-rounded-circular", {
  "tw-size-24": t === 24,
  "tw-size-32": t === 32,
  "tw-size-40": t === 40,
  "tw-size-48": t === 48,
  "tw-size-64": t === 64,
  "tw-size-96": t === 96,
  "tw-size-[120px]": t === 120
}, e), ...r }) }));
oe.displayName = "Avatar";
const ae = o.forwardRef(({
  className: e,
  ...t
}, r) => /* @__PURE__ */ i.jsx(K, { ref: r, loading: "lazy", className: w("tw-aspect-square tw-size-full", e), ...t }));
ae.displayName = "AvatarImage";
const se = (e) => {
  const t = {
    24: U,
    32: Y,
    40: te,
    48: R,
    64: g,
    96: g,
    120: g
  }, r = {
    96: "tw-size-56",
    // 56px
    120: "tw-size-72"
    // 72px
  }, n = e ? t[e] : R;
  return /* @__PURE__ */ i.jsx("div", { className: "tw-flex tw-justify-center tw-items-center tw-size-full tw-bg-gray-200 tw-rounded-circular", children: /* @__PURE__ */ i.jsx(n, { className: w("tw-text-gray-500", e && r[e]) }) });
}, ce = o.forwardRef(({
  className: e,
  ...t
}, r) => {
  const n = o.useContext(I);
  return /* @__PURE__ */ i.jsx(J, { ref: r, className: w("tw-flex tw-items-center tw-justify-center tw-size-full tw-rounded-circular", e), ...t, children: se(n) });
});
ce.displayName = "AvatarFallback";
export {
  oe as A,
  ce as a,
  ae as b
};
//# sourceMappingURL=Avatar.DWv-3vyX.js.map
